export default __webpack_public_path__ + "static/media/cat.9eca47a7.svg";